import {
    apiRequest,
    golonganList,
    golonganActive,
    golonganInactive
} from "../../../../../services/adapters/kepegawaian/golonganService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", golonganList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", golonganInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", golonganActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository